import { NgModule } from '@angular/core';
import { DragBoxDirective } from './drag-box.directive';
export class DirectivesModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        DragBoxDirective
    ],
    exports: [
        DragBoxDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DirectivesModule_tsickle_Closure_declarations() {
/** @type {?} */
DirectivesModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DirectivesModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
